<template>
  <Box>
    <div class="main-container">
      <h2>Visão Geral</h2>

      <form @submit.prevent="handleSubmit" class="main-form">
        <div class="inputs">
          <div class="inputs-row">
            <Select
              class="input-full"
              :options="typeOptions"
              legend="Tipo de aula"
              placeholder="Selecione um opção"
              :modelValue="type"
              @update:modelValue="$event => (type = $event)"
              :disabled="loading"
            />

            <SingleDate
              class="input-full"
              legend="Data"
              :modelValue="date"
              @update:modelValue="$event => (date = $event)"
            />

            <Select
              class="input-full"
              :options="turnOptions"
              legend="Turno"
              placeholder="Selecione um opção"
              :modelValue="turn"
              @update:modelValue="$event => (turn = $event)"
              :disabled="loading"
            />

            <Select
              class="input-full"
              :options="statusOptions"
              legend="Status"
              placeholder="Selecione um opção"
              :modelValue="status"
              @update:modelValue="$event => (status = $event)"
              :disabled="loading"
            />

            <Select
              class="input-full"
              :options="formatOptions"
              legend="Formato da aula"
              placeholder="Selecione um opção"
              :modelValue="format"
              @update:modelValue="$event => (format = $event)"
              :disabled="loading"
            />
          </div>

          <div class="actions">
            <div class="readonlies">
              <Input
                v-if="totalAlunos"
                legend="Total de Alunos"
                :modelValue="totalAlunos"
                readonly
                class="input-full"
              />

              <Input
                v-if="totalAulas"
                legend="Total de Aulas"
                :modelValue="totalAulas"
                readonly
                class="input-full"
              />
            </div>

            <div class="buttons">
              <Button
                type="button"
                @handle:click="clearInputs"
                text="Limpar"
                :fill="false"
                color="danger"
                :disabled="loading"
              >
                <CloseCircleOutline :size="18" />
              </Button>

              <Button type="submit" text="Consultar" color="primary" :disabled="loading">
                <Magnify :size="18" />
              </Button>
            </div>
          </div>
        </div>
      </form>

      <div class="chartCard" v-show="totalAlunos > 0 || totalAulas > 0">
        <div class="chartBox">
          <div class="container">
            <div :class="containerBodyClass">
              <canvas :id="aulasChartID"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Box>
</template>

<script>
import Box from 'core/Box'
import Button from 'core/Button'
import Input from 'core/Input'
import Select from 'core/Select'
import SingleDate from 'core/SingleDate'

import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'

import { aulasChart } from './charts/AulasChart'

export default {
  name: 'AulasGraphic',
  components: {
    Box,
    Button,
    Select,
    SingleDate,
    Input,

    Magnify,
    CloseCircleOutline,
  },
  data() {
    return {
      type: null,
      turn: null,
      status: null,
      format: null,
      date: '',
      totalAlunos: '',
      totalAulas: '',
      typeOptions: [
        {
          text: 'Aulas Práticas',
          value: 'pratica',
        },
        {
          text: 'Aulas Teóricas',
          value: 'teorica',
        },
      ],
      turnOptions: [
        {
          value: 'manha',
          text: 'Manhã',
        },
        {
          value: 'tarde',
          text: 'Tarde',
        },
        {
          value: 'noite',
          text: 'Noite',
        },
      ],
      statusOptions: [
        {
          value: 'Finalizada',
          text: 'Finalizada',
        },
        {
          value: 'Cancelada',
          text: 'Cancelada',
        },
        {
          value: 'Confirmada',
          text: 'Confirmada',
        },
        {
          value: 'Pendente',
          text: 'Pendente',
        },
      ],
      formatOptions: [
        {
          value: 'true',
          text: 'Online',
        },
        {
          value: 'false',
          text: 'Presencial',
        },
      ],
      loading: false,
      activeChart: false,

      aulasChartID: 'aulasChart',
      containerBodyClass: 'containerBody',
    }
  },
  methods: {
    clearInputs() {
      this.type = null
      this.turn = null
      this.status = null
      this.format = null
      this.date = ''
    },
    async handleSubmit() {
      if (!this.type) {
        this.$toasted.show('O tipo de aula é obrigatório.', {
          position: 'top-right',
        })

        return
      }

      this.$toasted.show('Pode demorar um pouco, aguarde...', {
        position: 'top-right',
      })

      this.loading = true

      const params = {
        tipoAula: this.type,
      }

      if (this.date) params.data = this.date
      if (this.turn) params.turno = this.turn
      if (this.status) params.status = this.status
      if (this.format) params.virtual = this.format

      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/dashboard/graficos/aulas`, {
          params,
        })
        .then(({ body }) => {
          const result = Object.values(body.dados)

          const alunos = result.map(item => item.alunos)
          const aulas = result.map(item => item.aulas)

          if (!alunos.length && !aulas.length) {
            this.$toasted.show('Sem resultados para sua pesquisa.', {
              position: 'top-right',
            })

            return
          }

          this.totalAlunos = alunos.reduce((a, b) => a + b, 0)
          this.totalAulas = aulas.reduce((a, b) => a + b, 0)

          this.activeChart = true

          aulasChart.createChart(this.aulasChartID, this.containerBodyClass, result)
        })
        .catch(({ body }) => {
          this.$toasted.show(body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    launchToast(mensagem) {
      this.$toasted.show(mensagem, {
        position: 'top-right',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h2 {
    margin-bottom: 0;
    font-weight: 700;
    font-size: 1.375rem;
    color: #202224;
  }

  .main-form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }

        .input-processo {
          max-width: 26.625rem;
        }
      }
    }

    .actions {
      display: flex;
      justify-content: space-between;
      gap: 1rem;

      .readonlies {
        display: flex;
        gap: 1rem;
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }
}

.chartCard {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chartBox {
  width: 100%;
  padding: 20px;
  /* border-radius: 20px; */
  /* border: solid 3px rgba(255, 26, 104, 1); */
  background: white;
  /* display: flex; */
}

.container {
  width: 100%;
  max-width: 100%;
  overflow-x: scroll;
}

.containerBody {
  height: 500px;
}
</style>
